export default __webpack_public_path__ + "static/us-950e972f896d783bdafbbe4702812a55.svg";